// extracted by mini-css-extract-plugin
module.exports = {"wrap_1000w":"wrap_1000w-1zDv9q8- clearfix","list":"list-39gd4vQo"};